import * as $ from 'jquery';

export const init = () => {
    // $('#rules').on('change', ()=>{
    //     $('.reservation-buttons').find('.primary-btn').toggleClass('disabled');
    // })
};